import React from "react";
import { useState, useEffect } from "react";

import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";

import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import VisorPdf from "../../../components/Visorpdf";
import Modal from "../../../components/Modal";

import TableFooter from "@mui/material/TableFooter";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import TablePagination from "@mui/material/TablePagination";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';

import api from "../../../service/api";
import Page from "../../../layout/Page";


const TableCellHead = styled(TableCell)(({ theme }) => ({
  color: "#3c4b64",
}));

const TablePaginationActions = (props) => {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
            <KeyboardArrowLeft />
          )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
            <KeyboardArrowRight />
          )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
};

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const CursosHistorial = (props) => {

      const [selected] = React.useState([]);
      const [page, setPage] = React.useState(0);
      const [rowsPerPage, setRowsPerPage] = React.useState(5);

      const breadcrumbs = [
        { nombre: "Inicio", ruta: "/" },
        { nombre: "Historial de cursos", ruta: "" },
      ];

    
      const TabContainer = styled(Box)(({ theme }) => ({
        [theme.breakpoints.up("lg")]: {
          paddingRight: theme.spacing(10),
          paddingLeft: theme.spacing(10),
        },
      }));
      
      const Row = styled(Grid)(({ theme }) => ({
        marginBottom: theme.spacing(3),
      }));   

      const handleChangePage = (event, newPage) => {
        setPage(newPage);
      };
             
      const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
      };
        
      const [datos, setDatos] = useState([]);
    
      const [showVisor, setShowVisor] = useState(false);       
      const cerrarVisor = () => setShowVisor(false);      
      const [certificado, setCertificado] = useState("");      
  
      const buscarCursosInscripto = () => {
        api
          .listaHistorialCursos()
          .then((res) => {          
            setDatos(res.data); 
          })
          .catch((e) => {
            console.log("Error al cargar los datos");
          });
      };
  
      const mostrarModalVisor  = (curso) => {
        setCertificado(curso.certificado);        
        setShowVisor(true);     
      }        

      useEffect(() => {
        buscarCursosInscripto();
      }, []);   
   
      return ( 
        <Page breadcrumbs={breadcrumbs}>
        <TabContainer>
          <Row container spacing={1}>
              <Grid item xs={12} sm={12} sx={{ marginBottom: 0 }}>
                <Typography variant="titulo"><b>HISTORIAL DE CURSOS</b></Typography>
              </Grid>
          </Row>
          <Row container spacing={1}>
            <Grid item xs={12} sm={12} sx={{ marginBottom: 0 }}>
              <Typography variant="cuerpo">
              A continuación te mostramos tu historial de cursos realizados.
              </Typography>
            </Grid>
          </Row>

          <TableContainer>
          <Table
            aria-label="tabla cursos disponibles"
            sx={{ border: "1px solid #dee2e6" }}
            size="small"
          >
            <TableHead>
              <TableRow>
                <TableCellHead padding="normal">
                  <b>Curso</b>
                </TableCellHead>
                <TableCellHead padding="normal">
                  <b>Año</b>
                </TableCellHead>
                <TableCellHead align="center" padding="normal">
                  <b>Estado</b>
                </TableCellHead>
                <TableCellHead align="center" padding="normal">
                  <b>Certificado</b>
                </TableCellHead>
              </TableRow>
            </TableHead>
            <TableBody>
              {datos.map((dato, index) => {
                return (
                  <TableRow
                    key={index}
                    sx={
                      index % 2 === 0
                        ? { backgroundColor: "#f2f2f2" }
                        : { backgroundColor: "#fff" }
                    }
                  >
                    <TableCell align="left" width="200">
                      {dato.nombre}
                    </TableCell>
                    <TableCell align="left" width="300">
                      {dato.anio}
                    </TableCell>
                    <TableCell align="center" width="100">
                      {dato.estado_alumno}
                    </TableCell>
                    <TableCell align="center" width="200">
                    <>
                    {(dato.certificado !== "" && dato.certificado !== null && (dato.estado_alumno === "Aprobado")) ? (
                            <>
                              <IconButton
                                  key="certificado"
                                  variant="dark"
                                  onClick={() => mostrarModalVisor(dato)}  
                                  size="sm"    
                                  title = "Descargar Certificado"              
                              >
                              <ShieldOutlinedIcon fontSize="small" />
                              </IconButton>
                            </> 
                            ) : (
                              <>
                              <IconButton
                                  key="certificado"
                                  variant="dark"                                   
                                  size="sm"    
                                  title = "Descargar Certificado"  
                                  disabled            
                              >
                              <ShieldOutlinedIcon fontSize="small" />
                              </IconButton>
                            </> 
                            )
                        }                        
                  </>                      
                  </TableCell>
                </TableRow>
                );
              })}
              {datos.length === 0 ? (
                <TableRow>
                  <TableCell colSpan="6" align="center">
                    <Typography variant="aclaracion">
                      Sin datos
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                  ""
                )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[
                    5,
                    10,
                    25,
                    { label: "Todos", value: datos.length },
                  ]}
                  count={datos.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  selected={selected}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>          
        </TableContainer>     
      </TabContainer>       


      <Modal open={showVisor} handleClose={cerrarVisor} closeButton>
        <VisorPdf url={"data:application/octet-stream;base64," + certificado} />
      </Modal>      

      </Page>
    );
}

export default CursosHistorial;